import React, { useEffect, useState, useCallback, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { TemplateWithTitle, TemplateForService } from 'pages';
import { UserList, UserItem } from 'components';
import { apiGetUserList } from 'api/ZimssaAPI';
import { useApiRequest, useServiceStatus } from 'hooks';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { USER_REGISTER, USER_INFO, USER_APPROVE_CHECK, USER_APPROVE_REJECT } from 'router/PageUrl';
import { PAGE_SERVICE_FAMILYMOVE, PAGE_SERVICE_MOVECLEANING } from 'commons/ZimssaString';

interface IPartnerUserInfo {
    partnerUserIdx: number;
    partnerUserDocStatus: string;
    partnerUserActiveStatus: string;
    profileImage: string;
    name: string;
    phone: string;
    isOwner: boolean;
}

function UserListView(): React.ReactElement {
    const history = useHistory();
    const { serviceIdx, serviceType, serviceDocStatus, serviceActiveStatus } = useServiceStatus();
    const { isOwner } = useContext(PartnerAuthState);
    const [userList, setUserList] = useState<Array<IPartnerUserInfo>>([]);
    const [fetchResult, fetchUserList] = useApiRequest<any>(apiGetUserList);
    const { serviceType: paramServiceType } = useParams<{ serviceType: string }>();

    useEffect(() => {
        if (serviceIdx) {
            fetchUserList({
                type: 'REQUEST',
                body: [serviceType, serviceIdx, 1],
            });
        }
    }, [fetchUserList, serviceIdx]);

    useEffect(() => {
        const { result, data } = fetchResult;
        if (result === 'success' && data.userList) {
            const responseData: Array<IPartnerUserInfo> = data.userList;

            setUserList(responseData);
        }
    }, [fetchResult]);

    const userListElement: React.ReactElement = (
        <UserList
            isOwner={isOwner}
            onClickAdd={useCallback(
                (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                    history.push(`${USER_REGISTER.url}/${serviceType}/${serviceIdx}`);
                },
                [history, serviceIdx, serviceType]
            )}
            onClickMore={() => {
                // TODO: 나중에 개발
            }}
        >
            {userList
                .map((item, index) => ({
                    profileImage: item.profileImage,
                    docStatus: item.partnerUserDocStatus,
                    activeStatus: item.partnerUserActiveStatus,
                    name: item.name,
                    phone: item.phone,
                    isOwner: item.isOwner,
                    onClick:
                        item.isOwner && item.partnerUserDocStatus === 'approve_reject'
                            ? undefined
                            : (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                                  let path: string = '';
                                  if (item.partnerUserActiveStatus === 'active' && item.partnerUserDocStatus === 'approve') {
                                      path = USER_INFO.url;
                                  } else {
                                      if (item.partnerUserDocStatus === 'approve_check') {
                                          path = USER_APPROVE_CHECK.url;
                                      } else {
                                          path = USER_APPROVE_REJECT.url;
                                      }
                                  }
                                  history.push(`${path}/${serviceType}/${serviceIdx}/${item.partnerUserIdx}`);
                              },
                }))
                .map((item, index) => (
                    <UserItem key={index} {...item} />
                ))}
        </UserList>
    );

    if (serviceDocStatus === 'approve' && serviceActiveStatus === 'active') {
        return (
            <TemplateForService isBackBtn={true} title={(() => {
              if (serviceType === 'familymove') {
                  return PAGE_SERVICE_FAMILYMOVE;
              }

              if (serviceType === 'move_cleaning') {
                  return PAGE_SERVICE_MOVECLEANING;
              }

              return '';
          })()} serviceIdx={serviceIdx ? Number(serviceIdx) : 0} serviceType={paramServiceType ? paramServiceType : ''}>
                {userListElement}
            </TemplateForService>
        );
    } else {
        return <TemplateWithTitle isBackBtn={true}>{userListElement}</TemplateWithTitle>;
    }
}

export default UserListView;
